import { useQueryClient, useQuery } from '@tanstack/react-query';
import { SitesService } from 'src/services/sites/sites.service';

type UseGetAllTagsQueryArgs = {
  customerId?: string;
  siteId?: string;
};

export const useGetAllTagsQuery = ({ customerId, siteId }: UseGetAllTagsQueryArgs) => {
  const queryClient = useQueryClient();

  const isEnabled = !!customerId && !!siteId;
  const queryKey = isEnabled ? ['tags', `${customerId}-${siteId}`] : ['tags', 'empty'];

  const {
    data: tags,
    isLoading,
    isError,
  } = useQuery({
    queryKey,
    queryFn: () => SitesService.getTags(customerId as string, siteId as string),
    staleTime: 1000 * 60 * 2, // 2 min cache
    enabled: isEnabled,
    placeholderData: () => queryClient.getQueryData(queryKey),
  });

  return { tags, isLoading, isError };
};
